import React from 'react';

interface SectionHeadingProps {
  /** Kleine Versalzeile über dem Titel, z. B. "Rundflüge & Gastflüge" */
  eyebrow: string;
  title: string;
  subtitle?: string;
  className?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  subtitle,
  className = '',
}) => {
  return (
    <div className={`text-center mb-10 ${className}`}>
      <p className="text-sm font-semibold tracking-[0.25em] uppercase text-primary-light">
        {eyebrow}
      </p>
      <h2 className="mt-3 font-serif text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">
        {title}
      </h2>
      {/* Horizontlinie – flache Kurve wie der Blick aus dem Cockpit */}
      <svg
        className="mx-auto mt-5 text-primary-light"
        width="140"
        height="14"
        viewBox="0 0 140 14"
        fill="none"
        aria-hidden="true"
      >
        <path d="M3 11 Q 70 -5 137 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      {subtitle && (
        <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
